<div class="projects-table-wrapper">
  <div class="grid-table">
    <div [ngStyle]="rowStyle" class="grid-row header-row">
      @for (header of tableHeaders; track header; let i = $index) {
        @switch (dataTypes?.[header.key]) {
          @default {
            <div
              matTooltipPosition="below"
              matTooltip="{{ header.tooltip }}"
              (click)="sortBy(header.key)"
              class="item header-{{ header.key }}"
            >
              <div class="inner-container">
                <span>
                  {{ header.name }}
                </span>
                <app-sort-arrow [hide]="lastSortedBy !== i" [isDesc]="!lastSortedAscending[i]"></app-sort-arrow>
              </div>
            </div>
          }
        }
        <ng-content select="[header-last-col]"></ng-content>
      }
    </div>
  </div>
  @if (isLoading) {
    <div>
      <mat-progress-bar class="custom-loading-progress-bar" mode="indeterminate"></mat-progress-bar>
    </div>
  }

  @if (tableData?.length === 0 && !isLoading) {
    <div class="error-msg">No Data.</div>
  }

  <ng-scrollbar
    #scrollbar
    [ngClass]="{ 'hide-totals': !totalsKeys?.length }"
    appearance="compact"
    class="std-scrollbar"
    orientation="vertical"
    (afterUpdate)="scrollbarUpdated()"
  >
    <!--    orientation="vertical"-->
    <div class="grid-table body" [ngClass]="[tableClass]">
      @for (data of tableData; track data; let last = $last) {
        @if (!data?.template_row) {
          <div [ngStyle]="rowStyle" class="grid-row project-row">
            @for (key of dataKeys; track key) {
              <!--  SWITCH based on TYPE-->
              <!--  IF key is not a special one than render content based on types-->
              @switch (dataTypes?.[key]) {
                @case ('money') {
                  <div class="item" [ngClass]="{ negative: data?.[key] < 0 }">
                    <span
                      [matTooltipClass]="{ 'negative-tooltip': data?.[key] < 0 }"
                      [matTooltip]="data?.[key] | money: 'positiveComa'"
                    >
                      {{ data?.[key] | money: 'shortSimpleSpace' }}
                    </span>
                  </div>
                }
                @case ('date') {
                  <div class="item">
                    {{ data?.[key] | datepipe: UTC_DATE }}
                  </div>
                }
                @case ('date-MMM_DD_YYYY') {
                  <div class="item">
                    {{ data?.[key] | datepipe: MMMDDYYYY }}
                  </div>
                }
                @case ('empty_field') {
                  <div class="item"></div>
                }
                @case ('formatted_address') {
                  <div class="item font-semibold">
                    <app-faded-text>
                      {{ data?.[key] }}
                    </app-faded-text>
                  </div>
                }
                @case ('type_unit_value') {
                  <div class="item font-bold">{{ data.type_unit_value }}</div>
                }
                @case ('name_with_options') {
                  <div class="item flex items-center">
                    <div class="item flex-1 text-navy-900 font-bold">
                      <app-faded-text>
                        {{ data?.[key] }}
                      </app-faded-text>
                    </div>
                    <app-styled-options-list
                      (selectedOption)="onOptionSelected($event, data)"
                      [listItems]="optionsList"
                    >
                      <div class="options">
                        <span class="cursor-pointer icon-options btn-small text-blue-700 px-5 m-auto"></span>
                      </div>
                    </app-styled-options-list>
                  </div>
                }
                @case ('template_1') {
                  <ng-container
                    [ngTemplateOutletContext]="data?.[key]?.context"
                    [ngTemplateOutlet]="data?.[key]?.template"
                  ></ng-container>
                }
                @case ('template_2') {
                  <ng-container
                    [ngTemplateOutletContext]="data?.[key]?.context"
                    [ngTemplateOutlet]="data?.[key]?.template"
                  ></ng-container>
                }
                @default {
                  <!--   any type-->
                  <div class="item">
                    {{ data?.[key] }}
                  </div>
                }
              }
            }
          </div>
        }
        @if (!last || !totalsKeys?.length) {
          <div [ngClass]="['grid border-bottom h-1 w-full', separatorClass]"></div>
        }
      }
    </div>
  </ng-scrollbar>
  @if (totalsKeys?.length) {
    <div class="grid-table totals">
      <div [ngStyle]="rowStyle" class="grid-row">
        @for (key of totalsKeys; track key) {
          @switch (key) {
            @default {
              @switch (isNumber(totalsData?.[key])) {
                @case (true) {
                  <div class="item" [ngClass]="{ negative: totalsData?.[key] < 0 }">
                    <span
                      [matTooltipClass]="{ 'negative-tooltip': totalsData?.[key] < 0 }"
                      [matTooltip]="totalsData?.[key] | money: 'positiveComa'"
                    >
                      {{ totalsData?.[key] | money: 'shortSimpleSpace' }}
                    </span>
                  </div>
                }
                @case (false) {
                  <div class="item">
                    {{ totalsData?.[key] }}
                  </div>
                }
              }
            }
          }
        }
      </div>
    </div>
  }
</div>
